import { Stack } from '@mui/material';
import { TournamentTypes } from 'common';
import { FC } from 'react';

import { TournamentCardBodyDetails } from './TournamentCardBodyDetails';
import { TournamentCardBodyHeader } from './TournamentCardBodyHeader';
import { TournamentCardBodyLeaderboard } from './TournamentCardBodyLeaderboard';
import { TournamentCardBodyTotalPrizes } from './TournamentCardBodyTotalPrizes';

interface TournamentCardBodyProps {
  tournament: TournamentTypes.TournamentConfig;
}

export const TournamentCardBody: FC<TournamentCardBodyProps> = ({ tournament }) => (
    <Stack
      sx={{
        height: 883,
        mx: 10,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        background: 'linear-gradient(to bottom, #151414, #000000)',
      }}>
      <TournamentCardBodyHeader tournament={tournament} />
      <TournamentCardBodyTotalPrizes tournament={tournament} />
      <TournamentCardBodyDetails tournament={tournament} />
      <TournamentCardBodyLeaderboard tournament={tournament} />
    </Stack>
  );
